import { addYears, endOfYear, startOfYear } from 'date-fns'

export const DEFAULT_START_MONTH = startOfYear(new Date(2020, 0))
export const DEFAULT_END_MONTH = endOfYear(addYears(new Date(), 1))
